import { createContext, type Dispatch, type ReactNode, type SetStateAction, useContext, useState } from "react";

interface ModalContextType {
	hoveredShiftNo: number;
	sethoveredShiftNo: Dispatch<SetStateAction<number>>;
}

const ModalContext = createContext<ModalContextType>({
	hoveredShiftNo: 1,
	sethoveredShiftNo: () => {},
});

export const useModalContext = () => useContext(ModalContext);

export const ModalProvider = ({ children }: { children: ReactNode }) => {
	const [hoveredShiftNo, sethoveredShiftNo] = useState(1);

	return <ModalContext.Provider value={{ hoveredShiftNo, sethoveredShiftNo }}>{children}</ModalContext.Provider>;
};
